import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page page-all-works" }
const _hoisted_2 = { class: "widgets" }

import { computed, watch, ref } from 'vue'
import { storeToRefs } from 'pinia'
import {
  ProductSelectVisibility,
  StackingSelectVisibility,
  useCameraFrameStore,
  useConfAndQueryStore,
  useLayoutStore,
  useProductStore,
  useStackingStore
} from '@/store'
import useSelect from '@/hooks/use-select'
import useAlert from '@/hooks/use-alert'
import DefaultCameraFrame from '@/components/all-works/DefaultCameraFrame.vue'
import ProductTile from '@/components/all-works/ProductTile.vue'
import ProductSelect from '@/components/all-works/ProductSelect.vue'
import StackingPanel from '@/components/all-works/StackingPanel.vue'
import StatkingContent from '@/components/all-works/StatkingContent.vue'
import StackingSelect from '@/components/all-works/StackingSelect.vue'
import StackingsPanel from '@/components/all-works/StackingsPanel.vue'
import SnapshotButton from '@/components/all-works/SnapshotButton.vue'
import SnapshotLayer from '@/components/all-works/SnapshotLayer.vue'
import { delay, throttle } from '@/utils'
import { ClickAction } from '@/data/report'


export default /*@__PURE__*/_defineComponent({
  __name: 'AllWorks',
  setup(__props) {

const layoutStore = useLayoutStore()
const { updateSnapshotButtonVisibility, updateSnapshotLayerVisibility } =
  layoutStore
const {
  isAllWorksMode,
  isDefaultCameraRendered,
  materialFilterVisibility,
  isSnapshotLayerVisible,
  hasManualLoading
} = storeToRefs(layoutStore)
const { hasAlertShown } = useAlert()
const productStore = useProductStore()
const { isAllWorksCat, selectedCategory, selectedAttributes } =
  storeToRefs(productStore)
const stackingStore = useStackingStore()

const {
  isStackingsSelected,
  selectedStackingSetKey,
  isStackingsSelectable,

  isSerieSelected,
  isProductsSelectable,
  selectedId,
  isFaceTryOn,
  isHandTryOn,
  selectableStackings,
  selectableProducts
} = useSelect()

const isStackingPanelIdle = ref(false)
const isStackingsPanelVisible = ref(false)

const cameraFrameStore = useCameraFrameStore()
const { isCameraLoading, snapshotResult } = storeToRefs(cameraFrameStore)
const { setTryOnType, setSkuId } = cameraFrameStore
const { isNetworkOk } = useAlert()
const { report } = useConfAndQueryStore()

const isShowLoading = computed(() => {
  return (
    !hasAlertShown.value && (isCameraLoading.value || hasManualLoading.value)
  )
})

const selectorVisibility = computed<
  StackingSelectVisibility | ProductSelectVisibility
>(() => {
  if (productStore.isQueryEmpty) return 'idle'
  if (isShowLoading.value) return 'loading'
  if (isSnapshotLayerVisible.value) return 'snapshotting'
  if (isStackingsSelected.value) {
    if (!isStackingsSelectable.value) return 'hidden'
    if (isStackingPanelIdle.value) return 'all-panel-shown'
    return 'bars'
  } else {
    if (!isProductsSelectable.value) return 'idle'
    if (materialFilterVisibility.value !== 'collapsed') return 'materials'
    return 'products'
  }
})

const showSnapLayer = throttle(() => {
  report(
    ClickAction.SNAPSHOT,
    isStackingsSelected.value
      ? stackingStore.selectedStacking?.titleString
      : productStore.selectedProduct?.skuId
  )
  snapshotResult.value = {}
  updateSnapshotLayerVisibility(true)
})

const showStackingsPanel = throttle(async () => {
  if (!isStackingPanelIdle.value) {
    isStackingPanelIdle.value = true
  }
  if (!isStackingsPanelVisible.value) {
    await delay(500)
    isStackingsPanelVisible.value = true
  }
})
const hideStackingsPanel = throttle(async (completed = false) => {
  if (isStackingsPanelVisible.value) {
    isStackingsPanelVisible.value = false
  }
  if (isStackingPanelIdle.value) {
    await delay(completed ? 100 : 500)
    isStackingPanelIdle.value = false
  }
})

watch(
  [isAllWorksMode, isStackingsSelected, selectedCategory, selectedId],
  async () => {
    // console.log('[[ Network ] Befor SetTryOnType ]', {
    //   id: selectedId.value,
    //   allworks: isAllWorksMode.value
    // })
    if (isAllWorksMode.value && selectedId.value) {
      const ok = await isNetworkOk()
      // console.log('[[ Network ] CheckNetwork ]', { id: selectedId.value, ok })
      if (ok) {
        if (isFaceTryOn.value) {
          if (isStackingsSelected.value) {
            setTryOnType('stacking', 'facial')
          } else {
            setTryOnType('single-item', 'facial')
          }
          setSkuId(selectedId.value)
        } else if (isHandTryOn.value) {
          if (isStackingsSelected.value) {
            setTryOnType('stacking', 'hand')
          } else {
            setTryOnType('single-item', 'hand')
          }
          setSkuId(selectedId.value)
        } else {
          console.error('[ SetIFrameUrl ] [[ Unexcepted Branch ]]', {
            id: selectedId.value,
            cat: selectedCategory.value
          })
        }
      }
    }
  },
  {
    immediate: true
  }
)

watch(
  [isShowLoading, selectableStackings, selectableProducts],
  () => {
    updateSnapshotButtonVisibility(
      isShowLoading.value ||
        (selectableStackings.value.length === 0 &&
          selectableProducts.value.length === 0),
      false
    )
  },
  { immediate: true }
)

watch(
  [selectableStackings, selectableProducts],
  ([stackings, products]) => {
    if (stackings.length) {
      console.log(
        `[[ Selection ] Selectable Stackings(${stackings.length}) / ${selectedStackingSetKey.value} ]`,
        stackings
      )
    } else if (products.length) {
      console.log(
        `[[ Selection ] Selectable Porducts(${products.length}) [ ${
          (isAllWorksCat.value
            ? ''
            : isSerieSelected.value
            ? 'Serial '
            : selectedAttributes.value.length > 0
            ? 'Attributed '
            : 'New ') + (productStore.selectedCategory || 'ITEMS') || '-'
        } ]]`,
        selectedAttributes.value.length,
        products.map(product =>
          product.hidden ? product.skuId + '(待确定)' : product.skuId
        )
      )
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isDefaultCameraRendered))
      ? (_openBlock(), _createBlock(DefaultCameraFrame, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_unref(isStackingsSelected))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(), _createBlock(StackingPanel, {
              key: 'stacking-panel:' + _unref(selectedStackingSetKey),
              "is-loading": isShowLoading.value,
              idle: isStackingPanelIdle.value
            }, {
              default: _withCtx(() => [
                _createVNode(StatkingContent)
              ]),
              _: 1
            }, 8, ["is-loading", "idle"])),
            (_openBlock(), _createBlock(StackingsPanel, {
              key: 'stackings-panel:' + _unref(selectedStackingSetKey),
              visible: isStackingsPanelVisible.value,
              onHide: _unref(hideStackingsPanel)
            }, null, 8, ["visible", "onHide"])),
            _createVNode(StackingSelect, {
              visibility: selectorVisibility.value as StackingSelectVisibility,
              onShowAll: _unref(showStackingsPanel)
            }, null, 8, ["visibility", "onShowAll"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(ProductTile, { "is-loading": isShowLoading.value }, null, 8, ["is-loading"]),
            (_openBlock(), _createBlock(ProductSelect, {
              key: _unref(productStore).selectionSource,
              visibility: selectorVisibility.value as ProductSelectVisibility,
              materialFilterVisibility: _unref(materialFilterVisibility),
              "onUpdate:materialFilterVisibility": _cache[0] || (_cache[0] = ($event: any) => (_isRef(materialFilterVisibility) ? (materialFilterVisibility).value = $event : null))
            }, null, 8, ["visibility", "materialFilterVisibility"]))
          ], 64)),
      _createVNode(SnapshotButton, {
        "is-snapshotting": _unref(isSnapshotLayerVisible),
        onShowMask: _unref(showSnapLayer)
      }, null, 8, ["is-snapshotting", "onShowMask"]),
      _createVNode(SnapshotLayer, {
        visible: _unref(isSnapshotLayerVisible),
        "snapshot-data": _unref(snapshotResult),
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(updateSnapshotLayerVisibility)(false)))
      }, null, 8, ["visible", "snapshot-data"])
    ], 512), [
      [_vShow, !_unref(hasAlertShown)]
    ])
  ]))
}
}

})